/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutoSaveDto } from '../../models/auto-save-dto';

export interface UpdateOrCreateIfNotExist1$Params {
      body: AutoSaveDto
}

export function updateOrCreateIfNotExist1(http: HttpClient, rootUrl: string, params: UpdateOrCreateIfNotExist1$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoSaveDto>> {
  const rb = new RequestBuilder(rootUrl, updateOrCreateIfNotExist1.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutoSaveDto>;
    })
  );
}

updateOrCreateIfNotExist1.PATH = '/autosaves';
